import {
  FETCH_USER_YEAR,
  ACTIVATE_STAT_CARD,
  TOGGLE_MOBILE_NAV,
  TOGGLE_COMMUNITY_STATS,
  SHARE_ON_FACEBOOK,
} from './constants'

import { selectPathname } from 'services/routing/selectors'
import { selectLoggedIn } from 'services/user/selectors'

export function fetchUserYear (userID, year) {
  return (dispatch, getState, { yearInReview }) => {
    return dispatch({
      type: FETCH_USER_YEAR,
      payload: yearInReview.getYear(userID, year),
    })
  }
}

export function activateStatCard (id) {
  return (dispatch) => {
    return dispatch({
      type: ACTIVATE_STAT_CARD,
      payload: id,
    })
  }
}

export function toggleMobileNav () {
  return (dispatch) => {
    return dispatch({
      type: TOGGLE_MOBILE_NAV,
    })
  }
}

export function shareOnFacebook (link) {
  const params = {
    link,
    method: 'feed',
    display: 'iframe',
  }

  return (dispatch, getState, { fb, clientEventManager }) => {
    const state = getState()
    const pageName = selectPathname(state)
    const loginStatus = selectLoggedIn(state)
    const network = 'facebook'

    const eventProps = {
      page_name: pageName,
      login_status: loginStatus,
      network,
    }

    clientEventManager.logEvent('page_shared', eventProps)

    return dispatch({
      type: SHARE_ON_FACEBOOK,
      payload: fb.postToFacebook(params),
    })
  }
}

export function shareOnTwitter (text) {
  return (dispatch, getState, { clientEventManager }) => {
    const state = getState()
    const pageName = selectPathname(state)
    const loginStatus = selectLoggedIn(state)
    const network = 'twitter'

    const eventProps = {
      page_name: pageName,
      login_status: loginStatus,
      network,
    }

    const twitterUrl = 'https://twitter.com/intent/tweet'
    const shareUrl = window.location.href

    window.open(
      `${twitterUrl}?url=${shareUrl}&text=${text}`,
      'tweet_window',
      'height=450,width=600'
    )

    clientEventManager.logEvent('page_shared', eventProps)
  }
}

export function clickAd (href) {
  return (dispatch, getState, { clientEventManager }) => {
    const state = getState()
    const pageName = selectPathname(state)
    const loginStatus = selectLoggedIn(state)

    const eventProps = {
      page_name: pageName,
      login_status: loginStatus,
    }

    clientEventManager.logEvent('ad_clicked', eventProps)
    window.location.href = href
  }
}

export function toggleCommunityStats () {
  return (dispatch) => {
    return dispatch({
      type: TOGGLE_COMMUNITY_STATS,
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/yearInReview/actions.js